
    <app-kontable
      id="dt_brand"
      title="{{ 'promotion.discountTypes' | translate }}"
      [columns]="['id', 'code', 'description']"
      [titles]="['#', 'promotion.code', 'promotion.description']"
      [source]="discountTypes"
      [showInfoButton]="true"
      [showRecoverButton]="false"
      [showDetailsButton]="false"
      [showAddButton]="true"
      [showGlobalFilter]="false"
      (onAdd)="showAdd()"
      (onEdit)="showEdit($event)"
      (onRemove)="delete($event)"
      *ngIf="!show">
    </app-kontable>
    <kv-promo-discount-type-detail
      *ngIf="show"
      [titlePage]="titlePage"
      [discountType]="addEditDiscountType"
      (hide)="toggleShow()"
      (saveDiscountType)="saveDiscountType($event)">
    </kv-promo-discount-type-detail>
  


// WEBPACK FOOTER //
// ./src/app/views/promotion/discount-type/discount-type.component.ts.DiscountTypeComponent.html